import { GetMoveMoney, MoveMoneySearch } from './../../../models/dashboard/moveMoney/moveMoney';
import { adminHttpClient } from "../../../commons/adminHttpClinet";


const getMoveMoneyByUser = (model:MoveMoneySearch): Promise<GetMoveMoney> => {
    return adminHttpClient.get(`/api/Admin/AdminMoveMoney/get-movemoney?SearchValue=${model.searchValue}&PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&OrderDescending=${model.orderDescending}&UserId=${model.userId}
    &SortColumn=${model.sortColumn}&Status=${model.status}&Type=${model.type}&CreatedFrom=${model.createdAt.from}&CreatedTo=${model.createdAt.to}
    `)
}
export default getMoveMoneyByUser;